// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"aa28bdd2","453":"62550548","777":"5c8dd4ce"}[chunkId] + ".chunk.js";
};